// This file was auto-generated by 'typesafe-i18n'. Any manual changes will be overwritten.
/* eslint-disable */

import { initI18nReact } from 'typesafe-i18n/adapters/adapter-react'
import type { Locales, Translations, TranslationFunctions, Formatters } from './i18n-types'
import { loadedLocales, loadedFormatters } from './i18n-util'

const { component: TypesafeI18n, context: I18nContext } = initI18nReact<Locales, Translations, TranslationFunctions, Formatters>(loadedLocales, loadedFormatters)

export { I18nContext }

export default TypesafeI18n
